import { api, podatki, type Shema } from '../api/odjemalec';
import { obrezano } from './delavnica';

type Oseba = Shema['OsebaPodatki'];

/** Nova stranka v vnosu: ime (obvezno), priimek, telefon, e-pošta; {@code null} = obrazec ni odprt. */
export type NovaStranka = { ime: string; priimek: string; telefon: string; email: string } | null;

/** Ali je v obrazcu nove stranke kaj vpisano (ob shranjevanju naloga se stranka ustvari). */
export function vpisanaNova(n: NovaStranka): boolean {
  return !!n && [n.ime, n.priimek, n.telefon, n.email].some((v) => v.trim() !== '');
}

/**
 * Ustvari stranko iz obrazca (osebe/kupci s kontaktom v enem klicu, obrezane vrednosti); ime je obvezno – napako
 * strežnika (polje »ime«) vrne klicatelju kot {@code NapakaApi}.
 */
export async function ustvariStranko(n: NonNullable<NovaStranka>): Promise<Oseba> {
  return podatki(
    api.POST('/api/osebe/{vrsta}/nova', {
      params: { path: { vrsta: 'kupci' } },
      body: {
        oseba: { id: 0, ime: obrezano(n.ime) ?? '', priimek: obrezano(n.priimek) },
        podrobnosti: { tel1: obrezano(n.telefon), email: obrezano(n.email) },
      },
    }),
  );
}
